import {
  detailsNavigationIds,
  detailsNavigationIdsAndValues,
} from '@stencil/hotels-utils/src/get-details-navigation-id-and-values';
import {scrollIntoViewDetails} from '@stencil/hotels-utils/src/scroll-into-view-details';
import {defaultTheme} from '@stencil/build-theme';
import {Fragment, useRef, useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';

// import ThingsYouShouldKnow from '../../../../../stories/components/hotels/DetailsPage/ThingsYouShouldKnow/ThingsYouShouldKnow';
import AmenitiesIconSelector from '../../../../components/AmenitiesIconSelector';
import {PrimaryLink} from '../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
import * as S from './Amenities.styles';
import {
  highlightedAmenitiesSelector,
  amenitiesSelector,
  hotelNameSelector,
} from '@stencil/hotels-cg-reducer/src/details/selectors';
import {isValidArray} from '@stencil/hotels-utils/src/common-utils';
import {omnitureThunk, omnitureConfig} from '@stencil/omniture-analytics/src';
import {DetailsPageComponents} from '@stencil/omniture-analytics/src/constants/details';

// SELECTORS
// HOOKS
// UTILS
// COMPONENTS
// COLOR Palette

const ListOfCategoryAmenities: React.FC<{amenities: {name?: string; subText?: string}[]}> = ({
  amenities,
}) => {
  return (
    <S.OneCategoryOfAmenitiesList>
      {amenities.map((amenityName, index) => (
        <Fragment key={index}>
          <S.OneCategoryOfAmenitiesListItem
            key={index}
            dangerouslySetInnerHTML={{__html: amenityName}}
          />
        </Fragment>
      ))}
    </S.OneCategoryOfAmenitiesList>
  );
};
const Amenities = () => {
  const amenitiesRef = useRef(null);
  const [moreAmenitiesShowState, setMoreAmenitiesShowState] = useState(false);

  const highlightedAmenities = useSelector(highlightedAmenitiesSelector);

  const dispatch = useDispatch();

  const allAmentiesData = useSelector(amenitiesSelector);
  const propertyNameOriginal = useSelector(hotelNameSelector);
  const propertyName =
    !propertyNameOriginal || propertyNameOriginal?.length <= 143
      ? propertyNameOriginal
      : propertyNameOriginal?.substring(0, 140) + '...';

  const cmappedfourAmenitiesList = highlightedAmenities?.slice(0, 4);

  // const isStaticDataLoading = useSelector(isStaticDataLoadingSelectorFn);

  // if (isStaticDataLoading) {
  //   return (
  //     <S.AmenitiesWrapper ref={amenitiesRef} id={detailsNavigationIds.amenities}>
  //       <AmenitiesDetailsLoader />
  //     </S.AmenitiesWrapper>
  //   );
  // }

  if (!allAmentiesData?.length) {
    return null;
  }

  return (
    <S.AmenitiesOuterWrapper ref={amenitiesRef} id={detailsNavigationIds.amenities}>
      <S.AmenitiesWrapper>
        {/* AMENITIES HEAD */}

        <S.AmenitiesHeaderStyled>
          Amenities {propertyName ? `at ${propertyName}` : ''}
        </S.AmenitiesHeaderStyled>

        {isValidArray(cmappedfourAmenitiesList) ? (
          <S.AmenitiesListBlock>
            <S.PopularAmenitiesTag>
              <S.PopularAmenitiesTagTextStyled>POPULAR AMENITIES</S.PopularAmenitiesTagTextStyled>
            </S.PopularAmenitiesTag>

            <S.AmentiesHorizontalListof4>
              {cmappedfourAmenitiesList.map((amenityName, index) => (
                <Fragment key={amenityName || index}>
                  <AmenitiesIconSelector
                    name={amenityName || ''}
                    styleProps={{
                      width: '2.4rem',
                      height: '2.4rem',
                    }}
                  />
                  <S.AmenityItemText>{amenityName || ''}</S.AmenityItemText>
                </Fragment>
              ))}
            </S.AmentiesHorizontalListof4>
          </S.AmenitiesListBlock>
        ) : null}

        {allAmentiesData?.length && (
          <S.CategorizedAmenitiesTableContainer showMore={moreAmenitiesShowState}>
            {(moreAmenitiesShowState ? allAmentiesData : allAmentiesData?.slice(0, 5))?.map(
              oneCategoryAmenities => {
                const amenityVisible = moreAmenitiesShowState
                  ? oneCategoryAmenities?.data
                  : oneCategoryAmenities?.data.slice(0, 4);
                return (
                  <S.OneCateoryOfAmenitiesContainer
                    key={oneCategoryAmenities.label}
                    id={oneCategoryAmenities.label}
                  >
                    <S.HeadingOneCategoryOfAmenitiesBlockStyled>
                      {oneCategoryAmenities.label}
                    </S.HeadingOneCategoryOfAmenitiesBlockStyled>

                    <ListOfCategoryAmenities amenities={amenityVisible || []} />
                  </S.OneCateoryOfAmenitiesContainer>
                );
              },
            )}
          </S.CategorizedAmenitiesTableContainer>
        )}
        <S.ShowHideLink>
          <PrimaryLink
            onClick={e => {
              e.preventDefault();

              dispatch(
                omnitureThunk(omnitureConfig.pages.DetailsUnif, omnitureConfig.events.ctaClick, {
                  cta: {
                    name: `${DetailsPageComponents.Amenities}_${
                      moreAmenitiesShowState ? 'View_Less' : 'View_All'
                    }`,
                    type: omnitureConfig.ctaType.Hyperlink,
                    componentName: DetailsPageComponents.Amenities,
                    destination: '',
                  },
                }),
              );
              // Toggle more amenities show state
              setMoreAmenitiesShowState(!moreAmenitiesShowState);

              // reset user's view to bring it to amenities container
              moreAmenitiesShowState &&
                scrollIntoViewDetails(
                  document.querySelector(detailsNavigationIdsAndValues.amenities.id),
                  {
                    duration: 500,
                  },
                );
            }}
          >
            {moreAmenitiesShowState ? 'Hide' : 'Show All Amenities'}
          </PrimaryLink>
        </S.ShowHideLink>
        {/* to be done later */}
        {/* <ThingsYouShouldKnow list={additionalHotelPoliciesData || []} /> */}
      </S.AmenitiesWrapper>
    </S.AmenitiesOuterWrapper>
  );
};

export default Amenities;
